const src = import.meta.ROLLUP_FILE_URL_5ueHAtn9JtiQ3lCiqsnAfg;
export default {
  src,
  srcSet: src + " " + 648 + "w",
  width: 648,
  height: 960,
};